import { motion } from "framer-motion";
import { CircleCheck, TriangleAlert, CircleX, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TONE_STYLES } from "@/lib/sim";

const TONE_ICONS = { CircleCheck, TriangleAlert, CircleX };

const EffectPill = ({ label, delta }) => {
  if (!delta) return null;
  const up = delta > 0;
  return (
    <span
      className={`text-[11px] font-semibold px-2 py-0.5 rounded-full tabular-nums ${
        up ? "bg-emerald-100 text-emerald-800" : "bg-rose-100 text-rose-800"
      }`}
    >
      {label} {up ? "+" : ""}{delta}
    </span>
  );
};

export const FeedbackPanel = ({ chosen, onContinue, isLast, willEndEarly }) => {
  const tone = TONE_STYLES[chosen.tone];
  const ToneIcon = TONE_ICONS[tone.icon];
  return (
    <motion.div
      data-testid="feedback-panel"
      role="status"
      aria-live="polite"
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
      className="overflow-hidden"
    >
      <div className={`mt-5 rounded-xl border p-5 ${tone.panel}`}>
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <div className="flex items-center gap-2">
            <ToneIcon className="h-5 w-5" />
            <span className={`text-[11px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full ${tone.badge}`}>
              {tone.label}
            </span>
          </div>
          <div className="flex items-center gap-1.5 flex-wrap">
            <EffectPill label="Safety" delta={chosen.effects.safety} />
            <EffectPill label="Trust" delta={chosen.effects.trust} />
            <EffectPill label="Time" delta={chosen.effects.time} />
            <EffectPill label="Resources" delta={chosen.effects.resources} />
          </div>
        </div>
        <p className="mt-3 text-sm sm:text-[15px] leading-relaxed">{chosen.feedback}</p>
      </div>

      <div className="mt-5 flex justify-end">
        <Button
          data-testid="continue-button"
          onClick={onContinue}
          className="rounded-full bg-emerald-800 hover:bg-emerald-900 text-white px-6 h-11"
        >
          {willEndEarly ? "See what happened" : isLast ? "See case summary" : "Continue"}
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </motion.div>
  );
};
